import React, { Fragment, useEffect } from "react";
import Header from "./common/header-component/header";
import Sidebar from "./common/sidebar-component/sidebar";
import RightSidebar from "./common/right-sidebar";
import Footer from "./common/footer";
import ThemeCustomizer from "./common/theme-customizer";
import { ToastContainer } from "react-toastify";
import { Outlet, useLocation } from "react-router-dom";

import { Provider, useDispatch, useSelector } from "react-redux";
import store from "../store";
import { NotificationsProvider } from "./common/header-component/notificationsContext";
import { fetchUser } from "../store/features/user/userSlice";

const AppLayout = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();

  // Define routes where the Footer should not appear
  const excludedRoutes = ["/reels", "reel/:id", "/users/userEdit"];
  const isExcludedRoute = excludedRoutes.includes(location.pathname);

  const { userInfo, loading } = useSelector((state) => state.user);
  useEffect(() => {
    // Fetch user data on the first render
    if (!userInfo) {
      dispatch(fetchUser());
    }
  }, [dispatch, userInfo]);

  return (
    <Fragment>
      {/* <Loader /> */}
      <div className="page-wrapper">
        <div className="page-body-wrapper">
          <NotificationsProvider>
            {" "}
            <Header />
          </NotificationsProvider>

          <Provider store={store}>
            <Sidebar />
          </Provider>
          <RightSidebar />
          <div className="page-body">
            <Outlet />
            {!isExcludedRoute && <Footer />}
          </div>
          <ThemeCustomizer />
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default AppLayout;
